import './styles/app.css';
import { route } from './router';

window.addEventListener('hashchange', () => route());
route();
